import LinkSizzleVideoLoadingImg from "../assets/images/sizzleloadingimg.png";

export const PublicAssets = {
    LinkSizzleVideoLoadingImg,
    LinkSizzleVideo:
        "https://nfpa-cod-production-public.s3.amazonaws.com/assets/videos/nfpa-link-sizzle-video.mp4",
};
